// TODO: remove this ft list after we closed all rest => GQL tasks
// if you remove this - check prod & stage!!! (need enabled all)
const gqlFeatures = {
  vacanciesGQL: 'vacanciesGQL',
  discountCodeGQL: 'discountCodeGQL',
  contactMailGQL: 'contactMailGQL',
  productPageGQL: 'productPageGQL',
  affiliateFormGQL: 'affiliateFormGQL',
  registerGQL: 'registerGQL',
  loginGQL: 'loginGQL',
  bloggerRequestGQL: 'bloggerRequestGQL',
}


export default gqlFeatures
